// src/components/EnhancedAnalytics.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import useScrollTracking from "../hooks/useScrollTracking";
import usePageTimeTracking from "../hooks/usePageTimeTracking";

const EnhancedAnalytics = () => {
  const location = useLocation();

  // Khởi tạo GA4
  useEffect(() => {
    ReactGA.initialize("G-6C6M09G88W");
  }, []);

  // Track pageview khi route thay đổi
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });

    // Track sự kiện route change
    ReactGA.event({
      category: "Navigation",
      action: "Page View",
      label: location.pathname,
    });
  }, [location]);

  // Sử dụng các hook tracking
  useScrollTracking();
  usePageTimeTracking(location.pathname);

  return null;
};

export default EnhancedAnalytics;
